import { useEffect, useState } from 'react';

export const useSearchCity = (search) => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const splitSearch = (input) => {
    const split = input.split(' ').map((s) => s.replace(/[^a-zA-Z0-9-']/g, ''));

    const letters = [];
    const numbers = [];

    split.forEach((item) => {
      if (/^[0-9]+$/.test(item)) {
        numbers.push(item);
      } else {
        letters.push(item);
      }
    });

    // Join the letters array into a single string
    const joinedLetters = letters.join(' ');

    // Return the combined result
    return [joinedLetters, ...numbers];
  };

  function mergeObjects(obj1, obj2) {
    const combinedArray = [...Object.values(obj1), ...Object.values(obj2)];

    const merged = combinedArray.reduce((acc, current) => {
      acc[current.nom] = current;
      return acc;
    }, {});

    return merged;
  }

  useEffect(async () => {
    if (search) {
      setLoading(true);
      const split = splitSearch(search);
      const resCity = await fetch(
        `https://geo.api.gouv.fr/communes?nom=${split[0]}&fields=code,nom,codesPostaux,departement,region&boost=population`
      );
      const resZip = await fetch(
        `https://geo.api.gouv.fr/communes?codePostal=${split[1]}&fields=code,nom,codesPostaux,departement,region&boost=population`
      );

      const jsonCity = resCity.ok ? await resCity.json() : {};
      const jsonZip = resZip.ok ? await resZip.json() : {};

      setResults(Object.values(mergeObjects(jsonCity, jsonZip)));
      setLoading(false);
    } else {
      setResults([]);
    }
  }, [search]);

  return { data: results, loading };
};
